import HeaderComponent from "../components/header.component";
import ScrollListComponent from '../components/scroll-list.component';

class AppContainer {
    init() {
        this.rootEl = document.querySelector('body');

        // Initialise any global components
        let header = new HeaderComponent();
        new ScrollListComponent();

        // handle docs mobile menu
        let docMenuToggle = document.querySelector('.js-toggle-doc-menu');
        if (docMenuToggle !== null) {
            let docsNavEl = document.querySelector('.js-docs-nav'),
                activeClass = "cfo-docs__nav--active";

            docMenuToggle.addEventListener('click', () => {
                if (docsNavEl.classList.contains(activeClass)) {
                    docsNavEl.classList.remove(activeClass);
                    header.show();
                } else {
                    docsNavEl.classList.add(activeClass);
                    header.hide();
                }
            });
        }
    }
}

export default AppContainer;
